import RecoverService from 'Domain/recoverPassword/RecoverService';

class Recover {
  static recover(params) {
    return new Promise((resolve, reject) => {
      RecoverService
        .recover(params)
        .then((success) => {
          const { data } = success;
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  }

  static change(params) {
    return new Promise((resolve, reject) => {
      RecoverService
        .change(params)
        .then((success) => {
          const { data } = success;
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  }
}

export default Recover;
